import { useNavigate } from 'react-router-dom'
import { Footer } from '../components/Footer'

export default function Legal() {
  const navigate = useNavigate()

  const handleNavigation = (href: string) => {
    navigate(href)
  }

  return (
    <div className="min-h-screen bg-[#d6dbdc] dark:bg-black">
      <div className="container mx-auto px-4 py-8 font-mono">
        <h1 className="text-2xl font-bold mb-4 text-black dark:text-white">Terms of Service and Privacy Policy</h1>
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">Terms of Service</h2>
          <p className="mb-4 text-gray-700 dark:text-gray-300">
            These are the Terms of Service for Seto Labs. By using our services, you agree to these terms.
          </p>
          <ul className="list-disc list-inside text-gray-700 dark:text-gray-300">
            <li>Use our services responsibly</li>
            <li>Respect intellectual property rights</li>
            <li>Do not engage in any illegal activities</li>
          </ul>
        </section>
        <section>
          <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">Privacy Policy</h2>
          <p className="mb-4 text-gray-700 dark:text-gray-300">
            This Privacy Policy describes how we collect, use, and protect your personal information.
          </p>
          <ul className="list-disc list-inside text-gray-700 dark:text-gray-300">
            <li>We collect only necessary information</li>
            <li>Your data is protected and never sold</li>
            <li>You can request access to your data at any time</li>
          </ul>
        </section>
      </div>
      <Footer onNavigate={handleNavigation} />
    </div>
  )
} 